import { Dropdown } from 'components/common'
import {
  FilterDateInput,
  FilterTextInput,
} from 'components/common/logFilterInputs'
import useLogFilters from 'hooks/useLogFilters'
import { FILTER_FIELD_NEW_SAP_BARCODE, SEEN_OPTIONS } from './utils'

const NewSapBarcodeFilterForm = () => {
  const { filters, setField } = useLogFilters(FILTER_FIELD_NEW_SAP_BARCODE)

  return (
    <div className="mb-6 flex flex-wrap items-end gap-4 rounded-xl border border-gray-200 bg-white px-5 py-4 shadow-sm">
      <FilterTextInput
        label="Search"
        value={filters.search || ''}
        onApply={(value) => setField('search', value)}
        placeholder="Search barcode, description..."
      />

      <FilterTextInput
        label="Barcode"
        value={filters.barcode || ''}
        onApply={(value) => setField('barcode', value)}
      />

      <FilterTextInput
        label="Description"
        value={filters.description || ''}
        onApply={(value) => setField('description', value)}
      />

      <div className="min-w-[200px]">
        <Dropdown
          name="isSeen"
          label="Status"
          options={SEEN_OPTIONS}
          defaultValue={filters.isSeen || ''}
          setValue={(_field: string, value: string) =>
            setField('isSeen', value)
          }
        />
      </div>

      <FilterDateInput
        label="From"
        value={filters.from || ''}
        onChange={(value) => setField('from', value)}
      />

      <FilterDateInput
        label="To"
        value={filters.to || ''}
        onChange={(value) => setField('to', value)}
      />
    </div>
  )
}

export default NewSapBarcodeFilterForm
